import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import { fetch, AreaInfoRsp, AreaInfo } from '@/fetch.ts';
import Rank1 from '@hooks/act/tab1and2/rank1.tsx';
import Rank2 from '@hooks/act/tab1and2/rank2.tsx';
import Rank3 from '@hooks/act/tab1and2/rank3.tsx';
import Rank4 from '@hooks/act/tab1and2/rank4.tsx';
import Rich from '@hooks/act/tab1and2/rich.tsx';
import AnchorDetect from 'react-anchor-scroll-detect';
const { useEffect, useState, useContext } = React;
declare global {
  interface Window {
    $: any
  }
}
interface TabsType {
  current: number,
  title: string,
  time: string,
  tips: string,
}
interface Props {
  index: number,
}
const Tab1and2: React.FC<Props> = props => {
  const [tabs] = useState<TabsType[]>([
    {
      current: 0,
      title: '海选赛',
      time: props.index === 1 ? '10.18-10.20' : '10.23-10.25',
      tips: props.index === 1 ? '各赛区前20名主播晋级下一个回合，19日和20日分两批晋级' : '各赛区前20名主播晋级下一个回合，24日和25日分两批晋级',
    },
    {
      current: 1,
      title: '淘汰赛',
      time: props.index === 1 ? '10.21-10.22' : '10.26-10.27',
      tips: props.index === 1 ? '晋级主播分成A组和B组，A组前6名晋级，B组前2名晋级' : '晋级主播分成A组和B组，A组前6名晋级，B组前2名晋级',
    },
    {
      current: 2,
      title: '擂台赛',
      time: props.index === 1 ? '10.23-10.24' : '10.28-10.29',
      tips: props.index === 1 ? '主播1V1对阵，胜利方晋级决赛；败方最强的主播同样晋级决赛' : '主播1V1对阵，胜利方晋级决赛；败方最强的主播同样晋级决赛',
    },
    {
      current: 3,
      title: '决赛',
      time: props.index === 1 ? '10.25-10.26' : '10.30-10.31',
      tips: props.index === 1 ? '各赛区主播进行比拼，决出各奖项最后的冠亚季军' : '各赛区主播进行比拼，决出各奖项最后的冠亚季军',
    },
  ])
  const { iEntStage, iGameStage, tabToastOpen } = useContext(StageDefault);
  const [iStage] = useState<number>(props.index === 1 ? iEntStage > 4 ? 4 : iEntStage : iGameStage > 4 ? 4 : iGameStage);
  const [current, Current] = useState<number>(iStage);
  const [areaList, AreaList] = useState<AreaInfo[]>([]);
  // const [sideHeight, setSideHeight] = useState<number>(1);
  const [showtab, SHOWTAB] = useState<boolean>(false);
  /* 防抖 */
  const debounce = (fn: any, wait: number) => {
    let timer: any = null;
    return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          fn();
        }, wait);
    }
  }
  useEffect(() =>　{
    const isChrome = window.navigator.userAgent.indexOf('Chrome') > -1;
    // const canSet = window.innerHeight - 60;
    // if (canSet < 1100) {
    //   setSideHeight(canSet / 1100);
    // } else {
    //   setSideHeight(1);
    // }
    if (isChrome) {
      window.$(window).on('scroll', debounce(handleScroll, 300));
      window.$(window).on('resize', debounce(() => SHOWTAB(false), 300));
    }
  })
  const handleScroll = () => {
    const marginH =  window.$(window).scrollTop();
    if (marginH >= 930 && document.body.offsetWidth > 1600) {
      SHOWTAB(true);
    }
    if (marginH <= 930 && document.body.offsetWidth > 1600) {
      SHOWTAB(false);
    }
  }

  useEffect(() => {
    fetch.StarGetAreaInfo(
      {
        lPid: 0,
      }
    )
      .then((rsp: AreaInfoRsp) => {
        // console.log('分区信息', JSON.stringify(rsp));
        AreaList(props.index === 1 ? rsp.vEntArea.value : rsp.vGameArea.value);
      })
  }, [])
  return (
    <div className='tab1and2'>
      <div className='tab1and2_nav'>
        {
          [tabs].map((item: any, index: number) => (
            <ul key={index}>
              {
                item.map((navItem: TabsType, Index: number) => (
                  <li
                    key={Index}
                    className={
                      current === (Index + 1) ? 'on' : ''
                    }
                    onClick={
                      () => {
                        if (Index + 1 > iStage) {
                          tabToastOpen('该赛程暂未开始，敬请期待');
                          return;
                        };
                        Current(Index + 1);
                      }
                    }
                  >
                    <h2>{navItem.title}</h2>
                    <i></i>
                    <p>{navItem.time}</p>
                    <div className='tab-tips'>{navItem.tips}</div>
                  </li>
                ))
              }
            </ul>
          ))
        }
      </div>
      {
        showtab &&
        <AnchorDetect
          className={props.index === 2 ? "sideBar-2 sideBar" : "sideBar-1 sideBar"}
          // style={{
          //   transform: `translate(0, -50%) scale(${sideHeight}, ${sideHeight})`,
          // }}
          items={[...areaList.map((item: AreaInfo) => ('area-' + item.iSubAreaId)), 'rich','top']}
          activeClass="active"
          offsetTop={150}
        >
          {
            areaList.map((item: AreaInfo, index: number) => (
              <li key={index}>
                {item.sAreaName}
              </li>
            ))
          }
          <li style={{color: 'rgb(255, 239, 187)'}}>神豪榜</li>
          <li>TOP <i /></li>
        </AnchorDetect>
      }
      { current === 3 && <div className='rank3banner'>{`赛程播报：${props.index === 1 ? '24' : '29'}号24点时，1v1获胜的主播和败方星光最高的主播晋级决赛`}</div> }
      <div
        className='ranklist'
      >
        {
          areaList.map((item: AreaInfo) => {
            switch (current){
              case 1:
                return (<Rank1 key={props.index + ':' + item.iSubAreaId} {...item} iAreaId={props.index === 1 ? 2 : 1} />)
              case 2:
                return (<Rank2 key={props.index + ':' + item.iSubAreaId} {...item} iAreaId={props.index === 1 ? 2 : 1} />)
              case 3:
                return (<Rank3 key={props.index + ':' + item.iSubAreaId} {...item} iAreaId={props.index === 1 ? 2 : 1} />)
              case 4:
                return (<Rank4 key={props.index + ':' + item.iSubAreaId} {...item} iAreaId={props.index === 1 ? 2 : 1} />)
            }
          })
        }
      </div>
      <Rich iAreaId={props.index === 1 ? 2 : 1} />
    </div>
  )
}

export default Tab1and2;